import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';
import styles from '../header.scss';
import storeManager from '../../../store/StoreManager';
import uiActions from '../../../actions/UIActions';
import uiReader from '../../../store/readHelpers/uiReader';
import deliverService from '../../../services/DeliveringService';

const OwnPreviewSwitcher = ({ isOwnPreviewEnabled }) => {
    const handleOwnPreviewMode = () => {
        storeManager.dispatch(uiActions.setOwnPreviewMode(!isOwnPreviewEnabled));
        deliverService.resetExam();
    };

    return (<div className={styles.ownSwitcher}>
        <div>
            <input
                type="checkbox"
                id="own-preview"
                checked={isOwnPreviewEnabled}
                onChange={handleOwnPreviewMode}
            />
            <label htmlFor="own-preview">
                { t('navigation.oneWay.preview') }
            </label>
        </div>
    </div>);
};

OwnPreviewSwitcher.propTypes = {
    isOwnPreviewEnabled: PropTypes.bool.isRequired,
};

const mapStateToProps = () => {
    return {
        isOwnPreviewEnabled: uiReader.isOwnPreviewEnabled(),
    };
};

export default connect(mapStateToProps)(OwnPreviewSwitcher);
